import React from 'react';
//style
import 'bootstrap/dist/css/bootstrap.css';
import './categorycontainer.styl';
//containers
import SimpleContainer from '../simplecontainer/SimpleContainer';
import SubCategory from './SubCategory'

class CategoryContainer extends React.Component {

  render(){
    this.idSelector = this.props.category && this.props.category.idSelector;
    this.columnsClass = this.props.cols === '2' ? 'double-column' : 'single-column';
    this.title = this.props.category &&  this.props.category.title;
    this.entries = [];
    this.props.category && this.props.category.subcategories && this.props.category.subcategories.forEach(sub=>{
      this.entries.push({
        subtitle: sub.subtitle,
        text: sub.text,
        text_2: sub.text_2,
        text_3: sub.text_3,
        text_4: sub.text_4,
        key: sub.key,
        linkAddress: sub.linkAddress,
        linkTarget: sub.linkTarget,
        linkText: sub.linkText,
        bulletItems: sub.bulletItems,
        logoBanners: sub.logoBanners
      });
    });

    return (
      <SimpleContainer id={ this.idSelector } color='white' containerClass='category-container padded-container'>
        <div className='col-xs-12 col-md-4 category-title'>
          <h1 dangerouslySetInnerHTML={{ __html: this.title }}></h1>
        </div>
        <div className={'col-xs-12 col-md-8 '+this.columnsClass}>
          <SubCategory subcategories={this.entries} />
          { this.props.component }
        </div>
      </SimpleContainer>
    );
  }
}

export default CategoryContainer;



// WEBPACK FOOTER //
// ./src/containers/categorycontainer/CategoryContainer.js